import tmhRequest from '@/config/tmhRequest'

export default {
    searchCustomer: function (data) {
        return tmhRequest({
            url: '/customer/ispa/customer/searchcustomer',
            method: 'post',
            params: data,
        })
    },
    searchCustomerCount: function (data) {
        return tmhRequest({
            url: '/customer/ispa/customer/searchcustomercount',
            method: 'post',
            data: data,
        })
    },
    searchCustomerByPage: function (data) {
        return tmhRequest({
            url: '/customer/ispa/customer/searchcustomerbypage',
            method: 'post',
            data: data,
        })
    },

    editCustomer: function (data) {
        return tmhRequest({
            url: '/customer/ispa/customer/editcustomer',
            method: 'post',
            data: data,
        })
    },
    multiEditCustomerForAdviser: function (data) {
        return tmhRequest({
            url: '/customer/ispa/customer/multieditcustomerforadviser',
            method: 'post',
            data: data,
        })
    },




}


// WEBPACK FOOTER //
// ./src/api/ispa/customer/customer.js